export const sx = {
    inner: {
        width: {
            xs: '100%',
            lg: 'auto'
        },
        '& .react-datepicker-popper':{
            zIndex:7777777777777777
        },
        '& input':{
            width:'100%'
        }
    },
    btn:{
        marginLeft:'auto',
        width:'10px',
        height:'10px',
        transition:'all .3s',
        '&:hover':{
            cursor:'pointer'
        }
    },
    innerBtn:{
        width:'100%',
        display:'flex',
        justifyContent:'flex-end'
    },
    label: {
        color: '#848581',
        fontWeight:'600'
    },
    innerLabel:{
        width:{
            xs:'100%',
            lg:'auto'
        }
    }
}